"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CANCEL_CONFIRM = exports.RESET_MODALS = exports.SAVE = exports.CONFIRM = exports.OK_CANCEL = exports.OK = exports.YES_NO_CANCEL = exports.YES_NO = exports.HIDE_DIALOG = exports.SHOW_DIALOG = exports.HIDE_WIZARD = exports.SHOW_WIZARD = exports.HIDE_MODAL = exports.SHOW_MODAL = void 0;
var SHOW_MODAL = 'SHOW_MODAL';
exports.SHOW_MODAL = SHOW_MODAL;
var HIDE_MODAL = 'HIDE_MODAL';
exports.HIDE_MODAL = HIDE_MODAL;
var SHOW_WIZARD = 'SHOW_WIZARD';
exports.SHOW_WIZARD = SHOW_WIZARD;
var HIDE_WIZARD = 'HIDE_WIZARD';
exports.HIDE_WIZARD = HIDE_WIZARD;
var SHOW_DIALOG = 'SHOW_DIALOG';
exports.SHOW_DIALOG = SHOW_DIALOG;
var HIDE_DIALOG = 'HIDE_DIALOG';
exports.HIDE_DIALOG = HIDE_DIALOG;
var YES_NO = 'YES_NO';
exports.YES_NO = YES_NO;
var YES_NO_CANCEL = 'YES_NO_CANCEL';
exports.YES_NO_CANCEL = YES_NO_CANCEL;
var OK = 'OK';
exports.OK = OK;
var OK_CANCEL = 'OK_CANCEL';
exports.OK_CANCEL = OK_CANCEL;
var CONFIRM = 'CONFIRM';
exports.CONFIRM = CONFIRM;
var SAVE = 'SAVE';
exports.SAVE = SAVE;
var RESET_MODALS = 'RESET_MODALS';
exports.RESET_MODALS = RESET_MODALS;
var CANCEL_CONFIRM = 'CANCEL_CONFIRM';
exports.CANCEL_CONFIRM = CANCEL_CONFIRM;